(async () => {
  const modalReady = () => new Promise((resolve) => {
    if (window.theme.modalReady) {
      resolve();
    }
    document.addEventListener('modalReady', resolve, { once: true });
  });

  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('notify-me-posted', class extends baseComponent.default {
    async render() {
      if (window.location.search.includes('contact_posted=true')) {
        await modalReady();
        this._triggerModal();
      }
    }

    _triggerModal() {
      const template = this.querySelector('template');
      if (!template || !template.id) return;
      this.trigger('openPopup', {
        target: `#${template.id}`,
        layout: 'small'
      });
    }
  });
})();
